import { render } from "./MagentoServicesIntegration.vue?vue&type=template&id=880e3888"
import script from "./MagentoServicesIntegration.vue?vue&type=script&lang=js"
export * from "./MagentoServicesIntegration.vue?vue&type=script&lang=js"

import "./MagentoServicesIntegration.vue?vue&type=style&index=0&id=880e3888&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__